import SlideOne from './slides/SlideOne'
import SlideTwo from './slides/SlideTwo'
import SlideThree from './slides/SlideThree'

export default function MeltingSeason() {
  return (
    <div>
      <SlideOne />

      <SlideTwo />

      <SlideThree />
    </div>
  )
}